/*
 * @Author: renjie.yin
 * @Date: 2022-11-09 13:59:21
 * @LastEditors: renjie.yin
 * @LastEditTime: 2022-11-12 13:42:20
 * @Description:
 */
import { isLeafNode, makeRecursiveMapper, mergeCellProps } from '../../utils'
import { TablePipeline } from '../pipeline'
export function mergeCellHover() {
  return (pipeline: TablePipeline) => {
    return pipeline.mapColumns(
      makeRecursiveMapper(col => {
        if (!isLeafNode(col)) {
          return col
        }
        const prevGetCellProps = col.getCellProps
        return {
          ...col,
          getCellProps(value: any, record: any, rowIndex: number) {
            const prevCellProps = prevGetCellProps?.(value, record, rowIndex)
            return mergeCellProps(prevCellProps, {
              onMouseEnter(e: React.MouseEvent<HTMLTableCellElement, MouseEvent>) {
                const InRangeRow = pipeline.ref.current.domHelper.getInRangeRowByCellEvent(e)
                InRangeRow.forEach((row: HTMLTableRowElement) => {
                  row.classList.add('row-hover')
                })
              },
              onMouseLeave(e) {
                const InRangeRow = pipeline.ref.current.domHelper.getInRangeRowByCellEvent(e)
                InRangeRow.forEach((row: HTMLTableRowElement) => {
                  row.classList.remove('row-hover')
                })
              }
            })
          }
        }
      })
    )
  }
}
